export const BranchEventNames = {
  ADD_TO_CART: 'Add to Cart',
  COMPLETE_REGISTRATION: 'Complete Registration',
  LOGIN: 'Login',
  PURCHASE: 'Purchase',
};
